export default  {
    "Index": "http://www.biaowu.com/",
    "Interest": "http://www.biaowu.com/",
    "News": "http://www.biaowu.com/nlist/1-1.html",
    "NewsDetail": "http://www.biaowu.com/HTML_News/News_{{newsid}}.html",
    "DocDetail": "http://www.biaowu.com/Library/LibraryDetail/{{docId}}.html",
    "Forget": "http://www.biaowu.com/",
    "About": "http://www.biaowu.com/contact.html",
    "Topic": "http://www.biaowu.com/BBS/index.html",
    "TopicDetail": "http://www.biaowu.com/bbs/topic_{{topicId}}.html",
    "PostTopic": "http://www.biaowu.com/BBS/TopicPosts.html?type=1",
    "product": "http://www.biaowu.com/plist/p1-0-1.html",
    "productOfPromotion": "https://www.biaowu.com/product/promotion/plist_1.html",
    "standard": "http://www.biaowu.com/slist_3/slist_3_0_0_1.html",
    "customize": "http://www.biaowu.com/Product/SearchOpenSearchNo.html",
    "standarddetail": "http://www.biaowu.com/s_{{classId}}/s_{{id}}.html",
    "Order": "http://www.biaowu.com/User/NeiOrders.html",
    "Invoice": "http://www.biaowu.com/AokeNei/GetNoApplyInvoice.html",
    "Intergral": "http://www.biaowu.com/User/CreditLogs.html",
    "Exchange": "http://www.biaowu.com/User/ExchangeProduct.html",
    "ExchangeDetail": "http://www.biaowu.com/",
    "IntergralRule": "http://www.biaowu.com/User/Integralrule.html",
    "Bill": "http://www.biaowu.com/AokeNei/GetUserAccount.html",
    "UserInfo": "http://www.biaowu.com/User/UserInfo.html",
    "FootPrint": "http://www.biaowu.com/",
    "Message": "http://www.biaowu.com/",
    "Attention": "http://www.biaowu.com/{{uid}}/MyFollowUser_1.html",
    "Unsubscribe": "http://www.biaowu.com/{{uid}}/FollowMyUser_1.html",
    "Collection": "http://www.biaowu.com/User/MyCollection.html",
    "Account": "http://www.biaowu.com/User/index.html",
    "ChangeMobile": "http://www.biaowu.com/User/BindAccount",
    "ChangePwd": "http://www.biaowu.com/User/BindAccount",
    "Prize": "http://www.biaowu.com/AokeNei/GetUserPrizes.html",
    "Suggest": "http://www.biaowu.com/User/Guestbook.html",
    "ShopCar": "http://www.biaowu.com/ShoppingCart",
    "SubmitOrder": "http://www.biaowu.com/ShoppingCart/Checkout",
    "OpenSearch": "http://www.biaowu.com/",
    "Personal": "http://www.biaowu.com/{{uid}}.html",
    "signIn": "http://www.biaowu.com/User/index.html",
    "Course": "http://www.biaowu.com/Course/index.html",
    "CourseCommentDetail": "http://www.biaowu.com/",
    "TopicCommentDetail": "http://www.biaowu.com/",
    "videodetail": "http://www.biaowu.com/TrainingDetail/{{id}}_1_1.html",
    "livedetail": "http://www.biaowu.com/LiveDetail/{{id}}_1_1.html",
    "videoRealtime": "http://www.biaowu.com/livePlay/{{id}}.html?type=1",
    "Address": "http://www.biaowu.com/User/Address",
    "addAddress": "http://www.biaowu.com/User/Address",
    "Chat": "http://www.biaowu.com",
    "OrderDetail": "http://www.biaowu.com/User/OrderDetail?num={{num}}",
    "NeiOrderDetail": "http://www.biaowu.com/User/NeiOrderDetail?ONO={{id}}",
    "Login": "http://www.biaowu.com/",
    "InitTel": "http://www.biaowu.com/",
    "ApplyInvoice": "http://www.biaowu.com/AokeNei/GetNoApplyInvoice.html",
    "Lottery": "http://www.biaowu.com/",
    "StartJob": "http://www.biaowu.com/",
    "StartJobReal": "http://www.biaowu.com/",
    "Home": "http://www.biaowu.com/",
    "Mine": "http://www.biaowu.com/User/index.html",
    "workStart2024":"http://www.biaowu.com/Event/workStart2024",
    "Search": "http://www.biaowu.com/",
    "virtuallyInfo":"https://www.biaowu.com/User/virtuallyInfoShow/{{id}}.html",
    "Error": "http://www.biaowu.com/"
}